export const MUSICEND = 'musicend'; // 00:15
export const MUSICGAME = 'musicgame'; // 04:52
export const MUSICLOST = 'musiclost'; // 00:02

export const DUDE = 'dude'; // 288 x 48
export const FOREST = 'forest'; // 1000 x 750
export const GREENSUN = 'greensun'; // 92 x 92
export const MINE = 'mine'; // 96 x 96
export const PLATFORM1 = 'platform1'; // 256 x 93
export const PLATFORM2 = 'platform2'; // 384 x 93
export const PLATFORM3 = 'platform3'; // 512 x 93
export const RAINBOW = 'rainbow'; // 174 x 174
export const SAW = 'saw'; // 128 x 128
export const SONICONE = 'sonicone'; // 98 x 167
export const SONICTWO = 'sonictwo'; // 38 x 42
export const WATER = 'water'; // 626 x 417
